import React from 'react'
import {
    StyledToggle,
    StyledToggleButton,
    StyledToggleBackground,
    StyledToggleSwitch,
    StyledToggleLabel,
    StyledToggleCheckbox,
} from 'component-library/buttons/ToggleButton/ToggleButton.styled'

export interface Props {
    checked?: boolean
    onToggle: (value: boolean) => void
    name: string
}

export const ToggleButton: React.FC<Props> = ({ onToggle, checked = false, name }) => (
    <StyledToggle>
        <StyledToggleCheckbox
            type="checkbox"
            checked={checked}
            onChange={() => onToggle(!checked)}
        />
        <StyledToggleLabel htmlFor={`${name}_${checked ? 'off' : 'on'}`}>
            {`Toggle ${name} ${checked ? 'off' : 'on'}`}
        </StyledToggleLabel>

        <StyledToggleButton onClick={() => onToggle(!checked)}>
            <StyledToggleBackground active={checked}>
                <StyledToggleSwitch />
            </StyledToggleBackground>
        </StyledToggleButton>
    </StyledToggle>
)

ToggleButton.displayName = 'ToggleButton'
